export default "__VITE_ASSET__BPgrD4rc__"